<template>
  <div class="join-container" :class="{active:!loading}">
    <div class="content">
      <div class="icon-plus"></div>
      <div class="line line-h"></div>
      <div class="line line-v"></div> 
      <img src="../assets/join-text-join.png" class="text text-join"/>
      <img src="../assets/join-chair.png" class="chair"/>
      <div class="text-us">
        <img src="../assets/join-text-us.png" class="text"/>
        <div class="position-group">
          <img src="../assets/join-position-1.png"/>
          <img src="../assets/join-position-2.png"/>
          <img src="../assets/join-position-3.png"/>
          <img src="../assets/join-position-4.png"/>
          <img src="../assets/join-position-5.png"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Join',
  data(){
    return {
      loading:true
    }
  },
  created(){
    this.$store.dispatch('changeTheme',"white");
  },
  mounted(){
    this.$nextTick(()=>{
      this.loading = false;
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('changeTheme','');
    this.loading = true;
    next();
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";
  @import "../common/theme.scss";
  .join-container {
    background-color: $themeColor;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

  }
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-60%,0);
    max-width: 1374px;
    width: px2percent( 1347 , 1920 ) ;
    
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: px2percent( 34, 1347 );
  }
  
  .chair{
    position: absolute;
    width:px2percent( 453 , 1347 );
    left: px2percent( 430 , 1347 );
    top: px2percent(218 , 718);
    opacity: 0;
  }
  .text-join {
    width:px2percent( 1031 , 1347 );
    transform: translate3d(-20%,0,0);
    opacity: 0;
  }
  .text-us {
    width:px2percent( 296 , 1347 );
    > .text {
      width: px2percent(280 , 296);
      margin-bottom: px2percent(23 , 296);
      transform: translate3d(20%,0,0);
      opacity: 0;
    }
    .position-group{
      width:px2percent( 296 , 296 );
      img {
        transform: translate3d(50%,0,0);
        opacity: 0;
        display: block;
        max-width: 100%;
        + img {
          margin-top: px2percent(30 , 296);
        }
      }
    }
  }
  .icon-plus{
    transform: scale(0);
    position: absolute;
    padding: px2percent(48/2,1347);
    width: 0;
    height: 0;
    left: px2percent(-8,1347);
    top: px2percent(-29,718);
    &:after,
    &:before{
      content: "";
      position: absolute;
      background: #000;
      top:50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
    }
    &:after {
      width: px2percent(8,48);
      height: 100%;
    }
    &:before {
      width: 100%;
      height: px2percent(8,48);
    }
  }
  .line {
    position: absolute;
    &.line-v {
      height: px2percent(671,537);
      width: 2px;
      left: px2percent(16,1347);
      top: px2percent(40,534);
      overflow: hidden;
      &:after {
        content: "";
        position: absolute;
        border-left: 2px dashed #000;
        left: 0;
        top: 0;
        height: 100%;
        transform: translate3d(0,-100%,0);
      }
    }
    &.line-h {
      width: px2percent(1276,1347);
      height: 2px;
      left: px2percent(50,1347);
      top: px2percent(-2,534);
      overflow: hidden;
      &:after {
        transform: translate3d(-100%,0,0);
        content: "";
        position: absolute;
        border-top: 2px dashed #000;
        left: 0;
        top: 0;
        width: 100%;
      }
    }
  }
  .active {
    .icon-plus {
      animation: icon_anim .9s linear forwards;
    }

    .text-join,
    .text-us > .text {
      animation: transform_anim .7s linear forwards;
      
    }
    .chair {
      animation: transform_anim .5s .4s linear forwards;
    }
    .line-v{
      &:after {
        animation: transform_anim 1.4s linear forwards;
      }
      
    }
    .line-h{
      &:after {
        animation: transform_anim 2s linear forwards;
      }
    }
    .position-group {
      @for $v from 1 to 7 {
        img:nth-child(#{$v}){
          animation: transform_anim .8s ($v - 1) * .1s + .8s  linear forwards;
        }
      }
    }
  }
  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
  @keyframes transform_anim {
    100%{
      transform: none;
      opacity: 1;
    }
  }
</style>
